import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { MyJobs } from "./MyJobs";
import { PageContainer } from "../shared/PageContainer/index.js";
export const JobsDashboard = () => {
  return /* @__PURE__ */ React.createElement(PageContainer, null, /* @__PURE__ */ React.createElement(Box, { p: ["16px", null, "24px"] }, /* @__PURE__ */ React.createElement(Box, { h: "38px", mb: "24px", pt: "7px" }, /* @__PURE__ */ React.createElement(Text, { textStyle: "heading-3", color: "gray.900" }, "My Jobs")), /* @__PURE__ */ React.createElement(MyJobs, null)));
};
